(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        })
        .state('update_management', {
            abstract: true,
            url: '/update-management',
            parent: 'app'
        })
        .state('alerting', {
            abstract: true,
            url: '/alerting',
            parent: 'app'
        })
        .state('dashboard', {
            abstract: true,
            url: '/dashboards',
            parent: 'app'
        })
        .state('kiosk', {
            abstract: true,
            url: '/kiosk',
            parent: 'app'
        })
        .state('testing', {
            abstract: true,
            url: '/testing',
            parent: 'app'
        });
    }
})();
